import React from "react";
import { Layout, Typography, Row, Col, Card } from "antd";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const challenges = [
    { title: "AI Algorithm Optimization", difficulty: "Hard", description: "Optimize machine learning algorithms for better performance." },
    { title: "Cybersecurity Capture The Flag", difficulty: "Medium", description: "Solve real-world security challenges and vulnerabilities." },
    { title: "Data Science Predictive Modeling", difficulty: "Hard", description: "Build a predictive model using structured datasets." },
    { title: "Blockchain Smart Contract Challenge", difficulty: "Medium", description: "Develop and secure smart contracts for blockchain applications." },
];

const Codewars = () => {
    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>JectHub Codewars</Title>
                <Paragraph>Test and enhance your skills with AI, Cybersecurity, and Data Science coding challenges.</Paragraph>
                <Row gutter={[16, 16]}>
                    {challenges.map((challenge, index) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            <Card title={challenge.title} bordered={false}>
                                <Paragraph><strong>Difficulty:</strong> {challenge.difficulty}</Paragraph>
                                <Paragraph>{challenge.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
};

export default Codewars;
